export const translations = {
  ro: {
    nav: {
      login: "Autentificare",
      signup: "Înregistrare Proprietar",
      dashboard: "Panou Control",
      logout: "Deconectare"
    },
    landing: {
      guestTitle: "Găsește cazarea perfectă în Iași",
      guestSub: "Alege dintre cele mai bune opțiuni de cazare apartamente în Iași, la vilă sau cazare tip pensiune. Localizări ideale în centru sau cazare lângă aeroport.",
      ownerTitle: "Administrează-ți proprietatea profitabil",
      ownerSub: "Platformă SaaS robustă pentru proprietari. Plăți sigure prin Stripe Connect și automatizare completă a rezervărilor.",
      ownerButton: "Vreau să devin client",
      searchPlaceholder: "Cazare în centru sau lângă aeroport?",
      startFree: "Începe Gratuit",
      features: ["Centru Iași", "Lângă Aeroport", "Vile Premium", "Apartamente Moderne"]
    },
    login: {
      title: "Autentificare Proprietar",
      sub: "Administrare cazare apartamente în Iași",
      email: "Adresă E-mail",
      password: "Parolă Securizată",
      continue: "Continuă",
      verifyTitle: "Verificare Securizată",
      verifySub: "Codul OTP a fost trimis la",
      verifyBtn: "Confirmă Codul",
      back: "Înapoi",
      noAccount: "Nu ai un cont?",
      createNow: "Creează unul acum",
      errors: {
        invalid: "Date de acces incorecte.",
        db: "Eroare de conexiune server.",
        otp: "Codul a expirat sau este greșit."
      }
    }
  },
  en: {
    nav: {
      login: "Login",
      signup: "Owner Signup",
      dashboard: "Dashboard",
      logout: "Logout"
    },
    landing: {
      guestTitle: "Find the perfect stay in Iași",
      guestSub: "Discover top-rated apartments in Iași, luxury villas, or cozy guesthouses. Perfect locations in the city center or near the airport.",
      ownerTitle: "Manage your property profitably",
      ownerSub: "Robust SaaS platform for owners. Secure payments via Stripe Connect and full booking automation.",
      ownerButton: "I want to be a client / Register",
      searchPlaceholder: "City center or near airport?",
      startFree: "Start for Free",
      features: ["City Center", "Near Airport", "Premium Villas", "Modern Apartments"]
    },
    login: {
      title: "Owner Login",
      sub: "Iași accommodation management",
      email: "Email Address",
      password: "Secure Password",
      continue: "Continue",
      verifyTitle: "Secure Verification",
      verifySub: "The OTP code was sent to",
      verifyBtn: "Confirm Code",
      back: "Back",
      noAccount: "No account?",
      createNow: "Create one now",
      errors: {
        invalid: "Incorrect credentials.",
        db: "Server connection error.",
        otp: "Code expired or incorrect."
      }
    }
  }
};